// extracted by mini-css-extract-plugin
module.exports = {"list":"list-1CCaEebJ","video":"video-Vu82y2EG","topic":"topic-2D9qUbmF","pic_box":"pic_box-3qqQp1KU","pic":"pic-25STh04J"};